import { render, staticRenderFns } from "./ApplyTransformer.vue?vue&type=template&id=b642fd7a"
import script from "./ApplyTransformer.vue?vue&type=script&lang=js"
export * from "./ApplyTransformer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports